import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { FormInputProps } from "../form-input";
import { FormItemLabel } from "./form-item-label";

export type JsonInputProps = Omit<FormInputProps, "formLayout">;

export const JsonInput: React.FC<JsonInputProps> = ({
  formItem,
  formData,
  setValue,
}) => {
  const resolveText = (): string => {
    const e = formData[formItem.name];
    if (e === undefined || e === null) return "";
    if (typeof e === "object") return JSON.stringify(e, null, 2);
    // if it's a string, try to detect if it's valid JSON and pretty-print it
    if (typeof e === "string") {
      const trimmed = e.trim();
      if (trimmed === "") return "";
      try {
        const parsed = JSON.parse(trimmed);
        return JSON.stringify(parsed, null, 2);
      } catch (_) {
        return e;
      }
    }
    return String(e);
  };

  const [text, setText] = useState<string>(resolveText());

  // keep local text in sync when external formData changes
  useEffect(() => {
    setText(resolveText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData[formItem.name]]);

  const handleBlur = () => {
    const trimmed = text.trim();
    if (trimmed === "") {
      setValue(undefined);
      return;
    }
    try {
      const parsed = JSON.parse(trimmed);
      setValue(parsed);
    } catch (_err) {
      // keep raw text if invalid JSON; validators can flag this
      setValue(text);
    }
  };

  return (
    <div className="_json-input.tsx json-input">
      <TextField
        id={formItem.name}
        value={text}
        onChange={(evt) => setText(evt.target.value)}
        onBlur={handleBlur}
        disabled={formItem.disabled}
        fullWidth
        multiline
        variant="outlined"
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
        minRows={4}
      />
    </div>
  );
};

export default JsonInput;
